import React from 'react';

import Select from 'antd/es/select';

import SelectFilter, { SelectFilterProps } from '@common/react/components/Forms/SelectFilter/SelectFilter';

import { DashboardTimeInterval, intervals } from '@commonTuna/react/components/Utils';

import { TimeIntervals } from '@app/components/Pages/Admin/Reports/Base/BaseReport';
import {
	AppointmentFiltersType,
} from '@app/components/Pages/Admin/Appointments/AppointmentsWithEditableTable/AppointmentsETFilters';

export const getExcludeIntervals = (partition: DashboardTimeInterval) => {
	return {
		[DashboardTimeInterval.Month]: [DashboardTimeInterval.Year],
		[DashboardTimeInterval.Week]: [DashboardTimeInterval.Year, DashboardTimeInterval.Quarter],
		[DashboardTimeInterval.Day]: [
			DashboardTimeInterval.Year,
			DashboardTimeInterval.Quarter,
			DashboardTimeInterval.Month,
		],
	}[partition];
};

interface Props {
	filters: AppointmentFiltersType;
	handleChange: (evt) => void;
	selectFiltersProps?: SelectFilterProps;
	excludeIntervals?: Array<DashboardTimeInterval>;
	className?: string;
}

const PartitionFilter: React.FC<Props> = ({
	filters, handleChange, selectFiltersProps, excludeIntervals, className = 'pull-right ml10',
}) => {
	const timeIntervals = React.useMemo(() => {
		return excludeIntervals ? TimeIntervals.filter((item) => !excludeIntervals?.includes(item)) : TimeIntervals;
	}, [excludeIntervals]);
	return (
		<SelectFilter
			additionalParams={filters}
			param="partition"
			onChange={handleChange}
			className={className}
			defaultValue={intervals.find((q) => q.interval === DashboardTimeInterval.Year)?.caption}
			currentValue={+filters.partition!}
			selectProps={{ style: { width: '105px' } }}
			{...selectFiltersProps}
		>
			{timeIntervals.map((item, index) => (
				<Select.Option
					key={item}
					value={item}
				>
					{intervals.find((q) => q.interval === item)?.caption}
				</Select.Option>
			))}
		</SelectFilter>
	);
};

export default PartitionFilter;
